import useIsMobile from '@/hooks/useIsMobile';
import useList from './useList';
import DebtListDesktop from './desktop';
import DebtListMobile from './mobile';

const DebtList = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useList();

  if (isMobile) {
    return <DebtListMobile viewModel={viewModel} />;
  }

  return <DebtListDesktop viewModel={viewModel} />;
};

export default DebtList;